<template>
  <el-dialog
    :close-on-click-modal="true"
    class="content-card-title"
    title="意见建议"
    :visible.sync="dialogVisible"
    width="550px"
  >
    <el-form
      ref="form"
      style="width: 700px"
      :model="form"
      label-width="100px"
      :inline="true"
      :rules="rules"
      label-position="right"
    >
      <el-form-item label="评分" prop="score">
        <div style="margin: 10px 0"></div>
        <el-rate v-model="form.score" show-text> </el-rate>
      </el-form-item>
      <el-form-item label="反馈类型 " prop="feedbackType">
        <el-radio-group v-model="form.feedbackType">
          <el-radio label="10">问题反馈</el-radio>
          <el-radio label="20">意见建议</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
          label="问题截图"
          class="form-item-full"
        >
          <UP
            uploadTitle="上传图片"
            @fileIdCb="uploadSuccess"
            :fileId="form.fileIds"
            limit="4"
            accept =".jpg, .bmp, .gif, .png, .jpeg"
          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <li>支持JPG、BMP、GIF、PNG、JPEG图片</li>
              </ul>
            </template></UP
          >
        </el-form-item>
      <el-form-item label="其他建议">
        <div style="margin: 10px 0"></div>
        <el-input
          type="textarea"
          placeholder="请输入您的问题或建议"
          v-model="form.content"
          maxlength="250"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          style="width: 180%"
        >
        </el-input>
      </el-form-item>

      <el-form-item label="联系电话" prop="number">
        <el-input style="width: 168%" v-model="form.number"  placeholder="请输入手机号或电话号码"></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱" prop="email">
        <el-input style="width: 168%" v-model="form.email" placeholder="请输入电子邮箱地址"></el-input>
      </el-form-item>
      <div style="margin-left: 280px">
        <el-button @click="dialogVisible = false" icon="el-icon-close"
          >取消</el-button
        >
        <el-button type="primary" @click="submit" icon="el-icon-check"
          >提交</el-button
        >
      </div>
      <div
        data-v-4796ed5d=""
        style="width: 0%"
        class="el-divider el-divider--horizontal"
      >
        <!---->
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { bidderMobilePhonePass } from '@/shared/validate'
import { submitPerformance } from '@/api/user'
import uploadE from '../../common/upload/uoload.vue'
import { FormItem } from 'element-ui'
export default {
  created() {},
  components: {
        UP: uploadE,
  },
  data() {
    return {
      dialogVisible: false,
      value: null,
      form: {
        number: '',
        email: '',
        score: null,
        content: '',
        feedbackType:'',
        fileIds:[],
        issueImg:''
      },
      rules: {
        number: [
          {
            required: true,
            trigger: 'change',
            validator: bidderMobilePhonePass,
          },
        ],
        email: [
          { required: true, message: '请输入电子邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
         feedbackType: [
            { required: true, message: '请选择反馈类型', trigger: 'change' }
          ],
        score: {
          required: true,
          validator: (r, v, callback) => {
            if (this.form.score && this.form.score > 0) {
              callback()
            } else {
              callback(new Error('请选择分数'))
            }
          },
        },
      },
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const fileIds = this.form.fileIds
          let issueImg = ''
          if(fileIds){
            fileIds.forEach((val,index,arr)=>{
              if(index != 0){
                issueImg = issueImg+'|'  
              }
              issueImg = issueImg+val
            })
            this.form.issueImg = issueImg
          }
          
          submitPerformance(this.form).then((res) => {
          if (res.code === 200) {
            this.$message.success("反馈成功")
            this.dialogVisible = false
            this.form.number = ''
            this.form.email = ''
            this.form.score = null
            this.form.content = ''
          }
        })
        } else {
          return false
        }
      })
    },
    uploadSuccess(res) {
      this.form.fileIds.push(res.url)
      this.$refs.form.validateField('fileIds')
    },
  },
}
</script>

<style scoped>
.left-title {
  float: left;
  font-size: 18px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 27px;
}
</style>
